export const API_BASE_URL = 'https://api.citizen.com.pk/api/'
export const IMG_BASE_URL = 'https://app.citizen.com.pk/'
// export const API_BASE_URL = 'http://127.0.0.1:8000/api/'
// export const IMG_BASE_URL = 'http://127.0.0.1:8001/'    
export const IMAGE_UPLOAD_URL = '/popup.jpg'

// Temporarily disabled — set to true to re-enable free delivery promos, thresholds, and city-based shipping
export const FREE_DELIVERY_ENABLED = false;

// Temporarily disabled — set to true to show the homepage announcement popup
export const POPUP_ENABLED = false;